<div class="banner-with-text news-banner">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="hdg">News</h1>
      </div>
    </div>
  </div>
</div>

<div class="blog-wrap">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-paginator
          [paginationId]="'server'"
          [currentPage]="pageNumber"
          [pageSize]="pageSize"
          (page)="onPageChange($event)"
          *ngIf="totalBlog > pageSize"
        ></app-paginator>
      </div>
    </div>
  </div>

  <div class="container">
    <div
      class="blog-part"
      *ngFor="
        let blog of blogData
          | paginate
            : {
                id: 'server',
                itemsPerPage: pageSize,
                currentPage: pageNumber,
                totalItems: totalBlog
              }
      "
    >
      <div class="row">
        <div class="col-md-4 col-lg-5 left-wrap">
          <a routerLink="{{ blog.id }}">
            <img
              class="blog-image img-fluid"
              alt="blog-image"
              [src]="blog.coverImagePath"
            />
          </a>
        </div>

        <div class="col-md-8 col-lg-7 right-wrap">
          <h1 class="blog-name">
            <a routerLink="{{ blog.id }}">{{ blog.title }}</a>
          </h1>
          <p class="blog-by">
            By <span class="author-name">{{ blog.author }}</span> on
            {{ blog.createdOn | date }}
          </p>
          <p class="blog-des" [innerHtml]="blog.content"></p>
          <div class="blog-read-more">
            <a routerLink="{{ blog.id }}">Read more</a>
          </div>
          <div class="shareTheBlog">
            <div class="row">
              <div class="col-12 col-md-4 mt-4">
                <p class="mb-0">Share Article To:</p>
                <a
                  class="mr-2"
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/facebook.svg" />
                </a>
                <a
                  class="mr-2"
                  href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/twitter.svg" />
                </a>
                <a
                  class="mr-2"
                  href="https://www.instagram.com/thebranfordgroup/?hl=en"
                  target="_blank"
                >
                  <img src="../assets/images/instagram.svg" />
                </a>
                <a
                  href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/linkedin.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-paginator
          [paginationId]="'server'"
          [currentPage]="pageNumber"
          [pageSize]="pageSize"
          (page)="onPageChange($event)"
          *ngIf="totalBlog > pageSize"
        ></app-paginator>
      </div>
    </div>
  </div>
</div>
